import { isNH } from "@/constants/NHConfig"
import {
  useBrandPoiModel,
  useCommonModel,
  useConfigModel,
  useControllerModel,
  useCustomParamsModel,
  useIndicatorModel,
  usePoisModel,
} from "@/models"
import { useCreation, useRequest, useBoolean } from "ahooks-v2"
import { Modal } from "antd"
import classNames from "classnames"
import type { FC } from "react"
import { useEffect, useState } from "react"
import { useLocation, useParams, useNavigate } from "react-router-dom"
import { getCitys, getSandtableDetail } from "@/api"
import type { RouterIdsVO } from "@/api"
import { defaultRange } from "@/constants/constant"
import { getCurrentPageType } from "@/util/commonUtils"
import "./index.scss"
// ==============================================
import { PageTabs, SecondaryTabs } from "@/components/Tab"
import Operation from "../Operation"
import BrandChoice from "./components/BrandChoice"
import AreaSelect from "./components/AreaSelect"
import TopDecoration from "./components/TopDecoration"
// ==============================================
const Header: FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { sandTableId, cityId, brandId } = useParams<RouterIdsVO>() as any
  const { configs, currentConfig, setCurrentConfig, setConfigs } = useConfigModel()
  const { clearAllCache } = useCommonModel()
  const { setPoiValue } = usePoisModel()
  const { isCityBrandChange } = useCustomParamsModel()
  const { isAllShow, theme } = useControllerModel()
  const { setBrandPoiValue } = useBrandPoiModel()
  const { setAllState: setIndicatorAllState } = useIndicatorModel()
  const [menuLeft, setMenuLeft] = useState<number>(400)
  const [sandTableType, setSandTableType] = useState<string>("")
  const [brandVisible, { setTrue, setFalse }] = useBoolean(false)
  const showName = currentConfig?.showName || "智能沙盘"
  const pathArr = location.pathname.split("/")
  const pageType = getCurrentPageType()

  // 城市或品牌是否改变
  const isChange = useCreation(() => {
    return isCityBrandChange()
  }, [isCityBrandChange])

  // 切换城市或品牌
  useEffect(() => {
    if (isChange) {
      // 清除所有缓存数据
      clearAllCache()
    }
  }, [isChange, clearAllCache])

  // 获取沙盘详情
  useRequest(() => getSandtableDetail(sandTableId), {
    refreshDeps: [sandTableId],
    onSuccess: (res) => {
      const { sandTableType } = res
      setSandTableType(sandTableType)
    },
    onError: () => {
      setSandTableType("")
    },
  })

  // 获取当前配置
  const { run: configRun } = useRequest(getCitys, {
    manual: true,
    onSuccess: (res) => {
      const area = res?.area?.slice() || []
      const nearbyEcologyRadius = res?.nearbyEcologyRadius

      setCurrentConfig({
        ...res,
      })
      setConfigs(area)
      // 小于默认值时赋值
      if (nearbyEcologyRadius && nearbyEcologyRadius < defaultRange) {
        setPoiValue({
          range: nearbyEcologyRadius,
        })
      }
    },
    onError: () => {
      setConfigs([])
    },
  })

  useEffect(() => {
    if (sandTableType) {
      // 获取当前配置
      configRun({
        brandId,
        cityId,
        sandTableType,
      })
    }
  }, [brandId, cityId, sandTableType, configRun])

  // 城市下拉change
  const setCityBrandIds = (areaId: number) => {
    // 清除所有缓存数据
    clearAllCache()
    // 清除缓存网点
    setBrandPoiValue(null)
    // 清空筛选条件
    setIndicatorAllState({
      screeningData: undefined,
    })
    // 跳转页面
    navigate(`/${sandTableId}/${brandId}/${areaId}/${pageType}`)
  }

  return (
    <>
      <div
        className={classNames(
          "header",
          `header-${theme}`,
          `container-${pathArr[pathArr.length - 1]}`,
        )}
      >
        {/* 顶部 */}
        <TopDecoration showName={showName} getMenuLeft={setMenuLeft} />
        {/* 一级菜单 */}
        <PageTabs left={menuLeft} />
        {/* 二级菜单 */}
        <div
          className={classNames("tabs-box", {
            "tabs-box-right": !isAllShow,
          })}
        >
          <SecondaryTabs />
        </div>
        {/* 城市下拉 */}
        <AreaSelect value={Number(cityId)} options={configs} onChange={setCityBrandIds} />
        {/* 品牌选择 */}
        {sandTableType && (
          <div className={classNames("branch-choice-btn", "ellipsis")} onClick={setTrue}>
            品牌选择
          </div>
        )}
        {/* 农行操作手册 */}
        {isNH && <Operation />}
      </div>
      {/* 品牌选择 */}
      <Modal
        destroyOnClose
        className="theme-modal"
        title="品牌选择"
        visible={brandVisible}
        width="65%"
        closable={false}
        onCancel={setFalse}
        footer={[]}
      >
        <BrandChoice sandTableType={sandTableType} onClose={setFalse} />
      </Modal>
    </>
  )
}

export default Header
